<template>
    <div>
        <vue-headful title="ABL Groupe | Accueil"/>
        <header class="jumbotron">
            <div class="content">
                <h1>ABL Groupe</h1>
                <p>Depuis 1980, ABL Groupe participe au développement, à l'étude et à la commercialisation de produits
                    métallurgiques selon plans et spécifications clients.</p>
                <p>Les produits de nos usines européennes sont livrés sous forme de barres laminées à chaud, extrudées à
                    chaud, étirées à froid, ainsi que des pièces issues de forge libre.</p>
                <p></p><br/>
                <p>Since 1980, ABL Group have been taking part in the development of metallurgical products according to
                    customers requests and specifications.</p>
                <p>The products manufactured in our european plants can be supplied in hot rolled, hot extruded and cold
                    drawn bars as well as open die forging parts.</p>
            </div>
        </header>

        <main>
            <div class="container">
                <h2>Produits / Products</h2>
                <section class="box--container">
                    <ProductBox v-for="(product, index) in require('../data/products').default" :product="product"
                                :key="index"/>
                </section>
            </div>
        </main>
    </div>
</template>

<script>
    import ProductBox from "../components/ProductBox"
    export default {
        name: "Home",
        components: {
            ProductBox
        }
    }
</script>

<style lang="scss" scoped>
    header.jumbotron {
        margin-top: -50px;
        color: white;
        display: flex;
        align-items: flex-end;
        position: relative;
        background: url('../assets/images/forgingdescendue.jpg') center center;
        background-size: cover;

        & .content {
            z-index: 2;
            width: 800px;
            margin-left: 60px;
            margin-top: 50px;
            margin-bottom: 100px;
            background: rgba(0, 0, 0, 0.35);
            border-radius: 2px;
            padding: 30px;

            & h1 {
                text-transform: uppercase;
            }
        }

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            //background-color: #000000;
            opacity: 0.5;
            z-index: 1;
        }

        p {
            font-size: 20px;
        }
    }
</style>